import styled from "styled-components";
import { viewSizeCalculator } from "../../utils";

export const Wrapper = styled.div`
  width: ${() => `${viewSizeCalculator(4)}`};
  height: ${() => `${viewSizeCalculator(4)}`};
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0.0625rem 0.3125rem #3333331a;
  cursor: pointer;

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const Popup = styled.div`
  position: absolute;
  top: ${() => `${viewSizeCalculator(6.45)}`};
  left: ${() => `${viewSizeCalculator(1.25)}`};
  padding: ${() => `${viewSizeCalculator(1)}`};
  background-color: #ffffff;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`};
  box-shadow: 0rem 0.0625rem 0.3125rem 0rem #3333331a;
  z-index: 101;
  color: #333333;
  height: 84vh;
`;

export const RightPopup = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  gap: ${() => `${viewSizeCalculator(3)}`};
  max-height: 67vh;
  padding: ${() => `${viewSizeCalculator(0.25)} ${viewSizeCalculator(0.5)}`};
  overflow-y: auto; /* Enables scrolling */
  padding-right: 8px; /* Prevents content from touching scrollbar */
  will-change: scroll-position;
  transform: translateZ(0);
  scroll-behavior: auto;
  -webkit-overflow-scrolling: touch;
  contain: layout style paint;
  isolation: isolate;
  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE and Edge */
  -ms-overflow-style: none;
`;

export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #333333;
  opacity: 20%;
  z-index: 100; /* Behind the popup but above everything else */
`;

export const PopupHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  border-bottom: ${() => `${viewSizeCalculator(1, true)} solid #ebebeb`};

  padding: ${() => `0 0 ${viewSizeCalculator(1.25)} 0`}; // 0 0 1.25rem 0;
`;

export const FilterIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem

  width: ${() => `${viewSizeCalculator(20.5)}`}; // 20.5rem

  svg {
    width: ${() => `${viewSizeCalculator(1.5)}`};
    height: ${() => `${viewSizeCalculator(1.5)}`};
  }
`;

export const Title = styled.div`
  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
`;

export const Reset = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  opacity: ${({ isDisabled }) => (isDisabled ? "30%" : "100%")};
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isDisabled }) => !isDisabled && "#007bff"};
`;

export const FilterBodyContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem

  margin-top: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
`;

export const Partition = styled.div`
  border-top: ${() => `${viewSizeCalculator(1, true)} solid #ebebeb`};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${() => `${viewSizeCalculator(0.625)}`}; // 0.625rem

  z-index: ${({ zIndex }) => zIndex};
`;

export const CheckboxLabel = styled.label`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 400;

  cursor: pointer;
`;

export const AdvancedSearch = styled.div`
  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  font-weight: 500;
  color: #007bff;

  text-align: right;

  cursor: pointer;
`;

export const FilterFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: ${() =>
    `${viewSizeCalculator(1.25)} ${viewSizeCalculator(
      1.5,
    )} 0 ${viewSizeCalculator(1.5)}`}; // 1.25rem 1.5rem 0 1.5rem
  margin-top: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem
`;

export const StyledButton = styled.button`
  border: ${() => `${viewSizeCalculator(1, true)} solid #333333`};
  outline: none;
  border-radius: ${() => `${viewSizeCalculator(1.25)}`}; // 1.25rem

  height: ${() => `${viewSizeCalculator(2.5)}`}; // 2.5rem
  width: ${({ width }) =>
    `${viewSizeCalculator(width ? width : 9.375)}`}; // 9.375rem

  padding: ${() =>
    `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.75)}`}; // 0.5rem 0.75

  font-size: ${() => `${viewSizeCalculator(0.8125)}`}; // 0.8125rem
  color: ${({ bgColor }) => (bgColor === "#333333" ? "#ffffff" : "#333333")};

  background-color: ${({ bgColor }) => bgColor || "#ffffff"};

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  opacity: ${({ disabled }) => (disabled ? "30%" : "1")};

  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: ${({ bgColor }) =>
      bgColor === "#A9A9A9" ? "#A9A9A9" : "#333333"};
    color: #ffffff;
    background-color: ${({ isCancel }) => isCancel && "#D9D9D966"};
    color: ${({ isCancel }) => isCancel && "#333"};
  }
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: ${(props) =>
    props.top
      ? `${viewSizeCalculator(props.top)}`
      : `${viewSizeCalculator(
          4.475,
        )}`}; // Use custom top if provided, else fallback to 4.475rem
  ${(props) =>
    props.right ? "right: 0;" : "left: 0;"} // Dynamically set left or right

  width: ${(props) =>
    props.customWidth
      ? `${viewSizeCalculator(props.customWidth)}`
      : "100%"}; // Use custom width if provided, else fallback to 100%
  /* background-color: #ffffff; */
  overflow: hidden;
  margin: 0;
  padding: ${(props) =>
    props.customPadding ? `${viewSizeCalculator(props.customPadding)}` : 0};
  list-style: none;
  z-index: 10;
  font-size: ${() => `${viewSizeCalculator(0.875)}`}; // 0.875rem
  font-weight: 400;
  z-index: 999;
`;

export const Option = styled.li`
  padding: ${() => `${viewSizeCalculator(1)}`}; // 1.25rem
  margin-left: ${() => `${viewSizeCalculator(0.625)}`};
  margin-right: ${() => `${viewSizeCalculator(0.625)}`};
  font-size: ${() => `${viewSizeCalculator(1)}`}; // 1rem
  font-weight: ${({ isActive }) => isActive && 600};
  color: #333333;
  background-color: ${({ isActive }) => (isActive ? "#F5F5F5" : "#ffffff")};
  cursor: pointer;
  transition:
    background-color,
    font-weight 0.3s ease-in-out;

  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: #f9f9f9f9;
  }

  border-radius: ${(props) =>
    props.customBorderRadius
      ? `${viewSizeCalculator(props.customBorderRadius)}`
      : "0px"};
`;

export const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: ${() => `${viewSizeCalculator(1)}`};
    height: ${() => `${viewSizeCalculator(1)}`};
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;

  gap: 1.5rem;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;

  font-weight: 700;
  font-size: ${() => `${viewSizeCalculator(1)}`};

  width: fit-content;
`;

export const Footer = styled.div`
  width: 100%;
  height: ${viewSizeCalculator(5.4)};
  padding: ${() => `0 ${viewSizeCalculator(1)}`};
  box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.05); /* Very light shadow */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: ${viewSizeCalculator(1.25)};

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  background-color: white;
  border-bottom-left-radius: ${() => `${viewSizeCalculator(1.25)}`};
  border-bottom-right-radius: ${() => `${viewSizeCalculator(1.25)}`};

`;

export const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000080;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition:
    transform 0.5s ease,
    opacity 0.5s ease;
`;

export const ModalContent = styled.div`
  background-color: #ffffff;
  padding: ${viewSizeCalculator(2.1875)};
  border-radius: ${viewSizeCalculator(1.5)};
  text-align: left;
  width: ${({ width }) => `${viewSizeCalculator(width ? width : 31)}`};
  position: relative;
`;

export const ModalCloseButton = styled.div`
  position: absolute;
  top: ${() => `${viewSizeCalculator(1)}`};
  right: ${() => `${viewSizeCalculator(1)}`};
  cursor: pointer;
`;

export const MessageContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: ${viewSizeCalculator(0.8)};
`;

export const MessageTitle = styled.h2`
  font-size: ${() => `${viewSizeCalculator(1.1)}`};
`;

export const MessageDescription = styled.p`
  color: #676767;
  font-size: ${() => `${viewSizeCalculator(1)}`};
`;

export const ModalFooter = styled.div`
  width: 100%;
  margin-top: ${viewSizeCalculator(3.8)};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${viewSizeCalculator(1.5)};
`;

export const Image = styled.img`
  width: ${viewSizeCalculator(4)};
`;

export const TextInput = styled.input`
  font-size: ${() => `${viewSizeCalculator(0.9)}`};
  font-weight: 400;
  background-color: transparent;
  width: 100%;
  height: 2.5rem;
  padding: ${() => `${viewSizeCalculator(0.5)} ${viewSizeCalculator(0.8)}`};
  margin-top: ${viewSizeCalculator(1.5)};
  border: 1px solid #ebebeb;
  border-radius: ${viewSizeCalculator(1)};
  outline: none;
  color: #333333;
`;
